import { ChangeDetectorRef, Component, OnInit, ViewChild } from '@angular/core';
import { FormBuilder, FormGroup } from '@angular/forms';
import { ThemePalette } from '@angular/material/core';
import { MatDialog } from '@angular/material/dialog';
import { MatPaginator, PageEvent } from '@angular/material/paginator';
import { MatSort } from '@angular/material/sort';
import { MatTableDataSource } from '@angular/material/table';
import { Category, Type } from '@classes/category/category';
import { Pagination } from '@classes/pagination/pagination';
import { PaginationRequest } from '@classes/pagination/pagination-request';
import { RecordsCoudPouce } from '@classes/records/record';
import { Step } from '@classes/step/step';
import { UserPlatform } from '@classes/user/user-platform';
import { faFileExcel, faPrint, faRedoAlt, faSearch, faTimes, faTrashAlt } from '@fortawesome/free-solid-svg-icons';
import { CategoriesService } from '@services/categories/categories.service';
import { CategoryListsService } from '@services/category-lists/category-lists.service';
import { ConvertDateService } from '@services/convert-date/convert-date.service';
import { InitFilterRecordsService } from '@services/init-filter-records/init-filter-records.service';
import { RecordsService } from '@services/records/records.service';
import { StepsService } from '@services/step/steps.service';
import { UsersService } from '@services/users/users.service';
import { SubscriptionBaseComponent } from 'app/shared/subscription-base/subscription-base';
import { OpendialogConfirmDeleteRecordComponent } from './opendialog-confirm-delete-record/opendialog-confirm-delete-record.component';

@Component({
  selector: 'app-records',
  templateUrl: './records.component.html',
  styleUrls: ['./records.component.scss']
})
export class RecordsComponent extends SubscriptionBaseComponent implements OnInit {
  [x: string]: any;

  // subscription = new Subscription();

  faFileExcel = faFileExcel;
  faSearch = faSearch;
  faRedoAlt = faRedoAlt;
  faTimes = faTimes;
  faPrint = faPrint;
  faTrashAlt = faTrashAlt;

  filterRecordsForm: FormGroup;
  searchForm: FormGroup;
  filterValue: string;
  recordsList: RecordsCoudPouce[];

  // displayedColumns: string[] = ['creation', 'step', 'tupe', 'inputSubCat', 'inputValue', 'output', 'outputSubCat', 'outputValue'];
  displayedColumns: string[] = ['creation', 'step', 'type', 'category', 'subcategory', 'value', 'delete'];
  dataSource: MatTableDataSource<RecordsCoudPouce>;

  length: number;
  pageSize = 10;
  pageSizeOptions: number[] = [1, 5, 10, 25, 50];
  pageEvent: PageEvent;
  color: ThemePalette = 'primary';
  today = new Date();
  previousDate = new Date();
  steps: Step[];
  type: Type[] = [];
  choiceType = ['Input', 'Output'];
  categories: Category[] = [];
  subCategories: Category[] = [];
  subSubCategories: Category[] = [];
  subSubSubCategories: Category[] = [];
  users: UserPlatform[];

  @ViewChild(MatSort, { static: false }) sort: MatSort;
  @ViewChild(MatPaginator, { static: false }) paginator: MatPaginator;

  filterValueRecords = null;
  sortValueRecords: string;
  paginationRecords: Pagination;
  pageNo = 0;
  arrayFilter: any;

  travels: any;

  constructor(
    private recordsService: RecordsService,
    private formBuilder: FormBuilder,
    private stepsService: StepsService,
    private categoryListService: CategoryListsService,
    private categoriesService: CategoriesService,
    private userService: UsersService,
    private cdr: ChangeDetectorRef,
    private convertDateService: ConvertDateService,
    private initFilterRecordsService: InitFilterRecordsService,
    private dialog: MatDialog
  ) {
    super();
    this.initFilterRecordsService.getFilter();
  }

  ngOnInit() {
    this.initSub();
    // this.initform();
    this.getUsers();
    this.getSetps();
  }

  filterRecords(origin: string): void {

    this.filterValueRecords = {
      username: null,
      step: null,
      category: null,
      dateFrom: null,
      dateTo: null
    };

    const step = this.f.step?.value;
    const type = this.f.type?.value;
    const category = this.f.category?.value;
    const subCategory = this.f.subCategory?.value;
    const subSubCategory = this.f.subSubCategory?.value;
    const subSubSubCategory = this.f.subSubSubCategory?.value;
    const username = this.f.username?.value !== 'Tous' ? this.f.username?.value : null;
    const from = this.f.from?.value;
    const to = this.f.to?.value;

    // this.filterValueRecords = {
    //   username: null,
    //   step: null,
    //   category: null,
    //   dateFrom: null,
    //   dateTo: null
    // };



    let categories = [];
    categories = [category?.id, subCategory?.id, subSubCategory?.id, subSubSubCategory?.id];
    const categoriesfilter = categories?.filter(id => id !== undefined).join('|');


    if (step) {
      this.filterValueRecords.step = step;
      if (type) {
        this.filterValueRecords.type = type;
        if (category) {
          this.filterValueRecords.category = categoriesfilter;
          // if (subCategory) {
          //   this.filterValueRecords.category = subCategory;
          //   if (subSubCategory) {
          //     this.filterValueRecords.category = subSubCategory;
          //   }
          // }
        }
      }
    }


    if (username) {
      this.filterValueRecords.username = username;
    }

    if (from) {
      this.filterValueRecords.dateFrom = this.convertDateService.convertDate(from);
    }

    if (to) {
      this.filterValueRecords.dateTo = this.convertDateService.convertDate(to, true);
    }

    switch (origin) {
      case 'submit':
        this.getRecordsWithFilterReturnFirstPage();
        break;
      case 'export':
        this.getFileForExportRecords();
        break;
      default:
        break;
    }

  }

  getCategories(info: any, origin: string, event?): void {

    const step = this.f.step;
    const type = this.f.type;
    const category = this.f.category;
    const subCategory = this.f.subCategory;
    const subSubCategory = this.f.subSubCategory;
    const subSubSubCategory = this.f.subSubSubCategory;

    switch (origin) {
      case 'user':
        this.steps = [];
        this.type = [];
        this.categories = [];
        this.subCategories = [];
        this.subSubCategories = [];
        this.subSubSubCategories = [];

        this.resetRecords(event);
        step.reset();
        type.reset();
        category.reset();
        subCategory.reset();
        subSubCategory.reset();
        subSubSubCategory.reset();



        break;
      case 'step':
        this.type = [];
        this.categories = [];
        this.subCategories = [];
        this.subSubCategories = [];
        this.subSubSubCategories = [];

        type.reset();
        category.reset();
        subCategory.reset();
        subSubCategory.reset();
        subSubSubCategory.reset();

        this.categoryListService.getCategoryList(info.id).subscribe(res => {
          this.type = res;
          if (this.type.length) {
            this.filterRecordsForm.get('type').enable();
          }
        });
        break;

      case 'type':
        this.categories = [];
        this.subCategories = [];
        this.subSubCategories = [];
        this.subSubSubCategories = [];

        category.reset();
        subCategory.reset();
        subSubCategory.reset();
        subSubSubCategory.reset();

        const typeForSearch = this.type.find(item => item.type === info && item.description === 'Catégorie');

        this.categoriesService.getCategories(typeForSearch.id).subscribe(res => {
          this.categories = res;
          if (this.categories.length) {
            this.filterRecordsForm.get('category').enable();
          }
        });
        break;

      case 'category':
        this.subCategories = [];
        this.subSubCategories = [];
        this.subSubSubCategories = [];

        subCategory.reset();
        subSubCategory.reset();
        subSubSubCategory.reset();

        if (info.subCategoryList?.id) {
          this.categoriesService.getCategories(info.subCategoryList.id).subscribe(res => {
            this.subCategories = res;

            if (this.subCategories.length) {
              this.filterRecordsForm.get('subCategory').enable();
            }
          });
        }

        break;
      case 'subCategory':
        this.subSubCategories = [];
        this.subSubSubCategories = [];

        subSubCategory.reset();
        subSubSubCategory.reset();

        if (info.subCategoryList?.id) {
          this.categoriesService.getCategories(info.subCategoryList.id).subscribe(res => {
            this.subSubCategories = res;

            if (this.subSubCategories.length) {
              this.filterRecordsForm.get('subSubCategory').enable();
            }
          });
        }

        break;
      case 'subSubCategory':
        this.subSubSubCategories = [];

        subSubSubCategory.reset();

        if (info.subCategoryList?.id) {
          this.categoriesService.getCategories(info.subCategoryList.id).subscribe(res => {
            this.subSubSubCategories = res;

            if (this.subSubCategories.length) {
              this.filterRecordsForm.get('subSubSubCategory').enable();
            }
          });
        }

        break;

      default:
        break;
    }
  }

  onPageRecordsChanged(pageEvent: PageEvent): void {
    this.paginationRecords.pageNumber = pageEvent.pageIndex + 1;
    this.getRecordsWithFilter();
  }

  resetFilter(): void {
    this.filterValueRecords = null;
    this.initform();
    this.type = [];
    this.categories = [];
    this.subCategories = [];
    this.subSubCategories = [];
    this.subSubSubCategories = [];

    this.getRecordsWithFilterReturnFirstPage();

    setTimeout(() => {
      if (!this.type.length) {
        this.filterRecordsForm.get('type').disable();
      }
      if (!this.categories.length) {
        this.filterRecordsForm.get('category').disable();
      }
      if (!this.subCategories.length) {
        this.filterRecordsForm.get('subCategory').disable();
      }
    }, 250);

  }

  getFileForExportRecords(): void {
    const newRequest = new PaginationRequest(
      this.filterValueRecords,
      this.sortValueRecords,
      this.paginationRecords.pageNumber,
      this.paginationRecords.totalRecords
    );

    this.recordsService.exportRecords(newRequest);
  }

  applyFilter(filterValue): void {
    this.filterValue = filterValue;
    this.dataSource.filter = filterValue.trim().toLowerCase();
  }

  resetSearch(): void {
    this.searchForm.get('keyword').setValue('');
    this.applyFilter('');
  }

  printPage(): void {
    const print = document.getElementById('print');
    window.print();
    // frame.contentWindow.focus();
    // frame.contentWindow.print();
  }

  getTypeValue(typeValue: string): string {
    let typeToReturn = '';
    switch (typeValue) {
      case 'Weight':
        typeToReturn = 'kg';
        break;
      case 'Number':
        typeToReturn = 'p.';
        break;

      default:
        break;
    }
    return typeToReturn;
  }

  resetRecords(event): void {
    const date = new Date();
    const year = date.getFullYear();
    const month = date.getMonth();
    const dateFrom = new Date(year, month, 1);

    if (event.value === 'Tous') {

      this.filterValueRecords = {
        username: null,
        step: null,
        category: null,
        dateFrom: null,
        dateTo: null
      };

      this.filterValueRecords.dateTo = this.convertDateService.convertDate(date.toString(), true);
      this.filterValueRecords.dateFrom = this.convertDateService.convertDate(dateFrom.toString());

      this.recordsService.getRecords(new PaginationRequest(this.filterValueRecords, this.sortValueRecords, 1));

    } else {
      this.filterValueRecords = {
        username: event.value,
        step: null,
        category: null,
        dateFrom: null,
        dateTo: null
      };

      this.filterValueRecords.dateTo = this.convertDateService.convertDate(date.toString(), true);
      this.filterValueRecords.dateFrom = this.convertDateService.convertDate(dateFrom.toString());

      this.recordsService.getRecords(new PaginationRequest(this.filterValueRecords, this.sortValueRecords, 1));
      this.getSetps();

    }

  }

  deleteRecord(idRecords: string) {
    const dialogRef = this.dialog.open(OpendialogConfirmDeleteRecordComponent, {
      data: { id: idRecords }
    });

    dialogRef.afterClosed().subscribe({
      next: () => { this.getRecordsWithFilterReturnFirstPage(); }
    });
  }

  get f() {
    return this.filterRecordsForm.controls;
  }

  private getRecordsWithFilterReturnFirstPage(): void {
    const newRequest = new PaginationRequest(
      this.filterValueRecords,
      this.sortValueRecords,
      1,
    );

    this.recordsService.getRecords(newRequest);
    this.searchForm.get('keyword').setValue('');
    this.filterValue = '';
  }

  private getRecordsWithFilter(): void {
    const newRequest = new PaginationRequest(
      this.filterValueRecords,
      this.sortValueRecords,
      this.paginationRecords.pageNumber,
    );

    this.recordsService.getRecords(newRequest);
  }

  private getUsers(): void {
    this.userService.getUser().subscribe(res => {
      this.users = res;
    });
  }

  private getSetps(): void {
    this.stepsService.getSteps().subscribe(res => {
      this.steps = res;
      // const form = document.getElementsByClassName('origin_step_category_inputs') as HTMLCollectionOf<HTMLElement>;

    });
    // this.filterRecordsForm.addControl('step', new FormControl(''));
  }

  private initSub(): void {
    const date = new Date();
    const year = date.getFullYear();
    const month = date.getMonth();
    const dateFrom = new Date(year, month, 1);

    this.filterValueRecords = {
      username: null,
      step: null,
      category: null,
      dateFrom: null,
      dateTo: null
    };

    this.filterValueRecords.dateTo = this.convertDateService.convertDate(date.toString(), true);
    this.filterValueRecords.dateFrom = this.convertDateService.convertDate(dateFrom.toString());

    this.recordsService.getRecords(new PaginationRequest(this.filterValueRecords, this.sortValueRecords, 1));
    this.subscription
      .add(
        this.recordsService.eventsListSubject
          .subscribe(events => {
            this.recordsList = events?.body;
            this.paginationRecords = events?.pagination;
            this.initRecordsTable();
          })
      )
      .add(
        this.initFilterRecordsService.arrayFilterCompleted$.asObservable().subscribe(res => {
          this.initform();
          this.cdr.detectChanges();
        })
      );

  }

  private initRecordsTable(): void {
    this.dataSource = new MatTableDataSource(this.recordsList);

    this.dataSource.sortingDataAccessor = (item, property) => {
      switch (property) {
        case 'step': return item.step.description;
        // case 'input': return item.inputCategory.name;
        // case 'output': return item.outputCategory.name;
        // case 'inputSubCat': return item.inputCategory.subCategory;
        // case 'outputSubCat': return item.outputCategory.subCategory;
        default: return item[property];
      }
    };

    this.dataSource.filterPredicate = (data: any, filter) => {
      const dataStr = JSON.stringify(data).toLowerCase();
      return dataStr.indexOf(filter) !== -1;
    };

    this.dataSource.sort = this.sort;

  }

  private initform(): void {

    const year = this.today.getFullYear();
    const month = this.today.getMonth();

    const firstDayOfMonth = new Date(year, month, 1);

    // this.previousDate.setDate(this.previousDate.getDate() - 7);

    this.filterRecordsForm = this.formBuilder.group({
      username: ['Tous'],
      from: [firstDayOfMonth],
      to: [this.today],
      step: [''],
      type: [{ value: '', disabled: true }],
      category: [{ value: '', disabled: true }],
      subCategory: [{ value: '', disabled: true }],
      subSubCategory: [{ value: '', disabled: true }],
      subSubSubCategory: [{ value: '', disabled: true }]
    });

    this.searchForm = this.formBuilder.group({
      keyword: ['']
    });
  }




}
